module.exports = __webpack_public_path__ + "img/iot1.e4ad4349.png";